import { render, staticRenderFns } from "./treeChevron.vue?vue&type=template&id=5879c436&scoped=true&"
import script from "./treeChevron.vue?vue&type=script&lang=js&"
export * from "./treeChevron.vue?vue&type=script&lang=js&"
import style0 from "./treeChevron.vue?vue&type=style&index=0&id=5879c436&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5879c436",
  null
  
)

export default component.exports